export class ApiEndPointsTask {
    addTask = "api/Task/AddTask";
    getTaskDetailByID = "api/Task/GetTaskDetailByID";
    getTaskList = "api/Task/GetTasks";
    UpdateTaskStatus = "api/Task/UpdateTaskStatus";
    getSubTasks = "api/Task/GetSubTasks";
    removeSubTasks ="api/Task/RemoveSubTasks";
    removeTasks ="api/Task/RemoveTasks";
    addTasklistFolder="api/TaskList/AddTasklistFolder";
    getTaskListFolders= "api/TaskList/GetTaskListFolders";
    addTaskList="api/TaskList/AddTasklist";
    getTaskLists="api/TaskList/GetTaskLists";
    renameTasklistFolder="api/TaskList/RenameTasklistFolder";
    removeTasklistFolder="api/TaskList/RemoveTasklistFolder";
    renameTasklist="api/TaskList/RenameTasklist";
    removeTasklist="api/TaskList/RemoveTasklist";
    getTaskByTaskList="api/Task/getTaskByTaskList";
    GetTaskGroupsByTaskList="api/Task/GetTaskGroupsByTaskList";
    reorderTaskList="api/Task/ReorderTasks";
    reorderTaskGroup="api/Task/ReorderTaskGroup";
    taskMovetoTaskList="api/Task/TaskMovetoTaskList";
    taskStatus = "api/TaskStatus/GetTaskStatuses"; //"api/TaskStatus/GetOfficeTaskStatuses"; 
    addTaskTemplate = "api/TaskTemplate/AddTaskTemplate";
    getTaskTemplates ="api/TaskTemplate/GetActiveTaskTemplates";// "api/TaskTemplate/GetTaskTemplates";
    getActiveTaskTemplateCategories ="api/TaskTemplate/GetActiveTaskTemplateCategories";
    updateTaskTemplate = "api/TaskTemplate/UpdateTaskTemplateTasks";
    getSharedAccesslRoles = "api/ManageRole/GetAllRolesToLinkContactCompanyCore";
    shareTaskListFolder="api/TaskList/ShareTaskListFolder";
    getTasklistFolderSharedWithMe="api/TaskList/GetTasklistFolderSharedWithMe";
    addEditTaskGroup= "api/TaskList/AddEditTaskGroup";
    removeTaskGroup= "api/TaskList/RemoveTaskGroup";
    getTaskTemplateEmailLog = "api/TaskList/GetTaskTemplateEmailLog";
    sendManualReminderforTask="api/Task/SendManualReminderforTask";
    getSingleTaskTemplates="api/TaskTemplate/GetSingleTaskTemplates";
    importTaskFromTemplate="api/TaskTemplate/ImportTaskFromTemplate";
    addSingleTaskTemplate="api/TaskTemplate/AddSingleTaskTemplate";
    archivedTaskList="api/TaskList/ArchivedTaskList";
    archivedTask ="api/Task/ArchivedTask";
    getArchivedTaskLists="api/TaskList/GetArchivedTaskLists";
    getArchivedSingleTaskLists="api/Task/GetTasks";
    makeTaskRequired = "api/Task/MakeTaskRequired";
    triggerTaskGroup = "api/Task/TriggerTaskGroup";
    changeGroupType = "api/TaskList/ChangeGroupType";
    makeTaskExternal = "api/Task/MakeTaskExternal";
    getAllSubFoldersForFolder = "api/Core/GetAllSubFoldersForFolder";
    getTasklistInternalUrl = "api/TaskList/GetTasklistInternalUrl";
    resendTasklistURL ="api/TaskList/ResendTasklistURL";
    getTasklistFolderSharedRoles="api/TaskList/GetTasklistFolderSharedRoles";
    setProcessStageforTasklistGroup="api/TaskList/SetProcessStageforTasklistGroup";
}
